const r = {
  "cdr-form-error": "cdr-form-error_16-2-1",
  "cdr-form-error__icon": "cdr-form-error__icon_16-2-1",
  "cdr-form-group": "cdr-form-group_16-2-1",
  "cdr-form-group--error": "cdr-form-group--error_16-2-1",
  "cdr-form-group--disabled": "cdr-form-group--disabled_16-2-1",
  "cdr-form-group__optional": "cdr-form-group__optional_16-2-1",
  "cdr-form-group__required": "cdr-form-group__required_16-2-1",
  "cdr-form-group__wrapper": "cdr-form-group__wrapper_16-2-1"
};
export {
  r as default
};
